<template>
  <div class="container-fluid">
    <input id="article-files" v-if="galleryOptions !== null" v-file-uploader="galleryOptions" type="file" name="files" class="gallery_media" />
  </div>
</template>

<style lang="scss" scoped>
</style>

<script src="../../../../assets/libs/fileuploader-2.2/jquery.fileuploader.min.js" type="text/javascript"></script>

<script>

import VueFileUploader from "./../../../../directives/VueFileUploader.js";

export default {
  name: "ArticleImages",
  components: {},
  directives: {
    VueFileUploader
  },
  props: ['article'],
  data() {
    return {
      galleryOptions: null
    };
  },
  mounted() {
    var files = [];

    if (this.article.files) {
      files = this.article.files.map(file => (
      {
          name: file.title,
          size: file.size,
          type: file.mimeType,
          file: file.url,
          data: {
            url: file.url
          }
        }
      ));
    }

    const url = process.env.VUE_APP_API +'/ArticleFiles/' + this.article.articleId;

    this.galleryOptions = {
      name: 'article-files',
      extensions: null,
      showName: true,
      showMain: false,
      deletingImage: false,
      uploadUrl: url,
      deleteUrl: url,
      sortUrl: url,
      files: files
    };
  },
  beforeDestroy: function() {
  },
  methods: {}
};
</script>